import flatpickr from 'flatpickr/dist/flatpickr.min.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';

const datepicker = document.querySelectorAll('.js-datepicker');
const datepicker2 = document.querySelectorAll('.js-datepicker-2');

let minDate = new Date();
minDate = minDate.setDate(minDate.getDate() + 7);
let minDateNow = new Date();
minDateNow = minDateNow.setDate(minDateNow.getDate());

if(datepicker) {
  flatpickr('.js-datepicker', {
    locale: Japanese,
    altInput: true,
    altFormat: 'Y年m月d日（D）',
    dateFormat: 'Y-m-d',
    minDate: minDate,
    disableMobile: false,
    disable: [
      function(date) {
        return (date.getDay() === 0 || date.getDay() === 6);
      },
    ],
  });
}

if(datepicker2) {
  flatpickr('.js-datepicker-2', {
    locale: Japanese,
    altInput: true,
    altFormat: 'Y年m月d日（D）',
    dateFormat: 'Y-m-d',
    minDate: minDateNow,
    disableMobile: false,
    disable: [],
  });
}

// 選択肢変更

const selectDept = document.getElementById('inputDept');
const selectCat = document.getElementById('inputCat');
const dateBox = document.getElementById('formDateBox');

let deptVal;
let catVal;

const cat01 = ['募集職種について','選考プロセスについて','応募方法について','勤務条件/福利厚生について','その他'];
const cat02 = ['個別病院見学','インターンシップに関するお問い合わせ','資料請求','採用試験に関するお問い合わせ','奨学金に関するお問い合わせ','潜在看護職研修に関するお問い合わせ','その他お問い合わせ'];
const cat03 = ['個別病院見学','インターンシップに関するお問い合わせ','採用に関するお問い合わせ','その他のお問い合わせ'];
const cat04 = ['個別病院見学','採用に関するお問い合わせ','その他のお問い合わせ'];

if (selectDept) {
  selectDept.addEventListener('change', () => {
    deptVal = selectDept.value;
    selectCat.innerHTML = '';

    if(deptVal == '総務課 採用担当') {
      for(let i = 0; i < cat01.length; i++){
        let option = document.createElement('option');
        option.value = cat01[i];
        option.textContent = cat01[i];
        selectCat.appendChild(option);
      }
    } else if(deptVal == '看護部') {
      for(let i = 0; i < cat02.length; i++){
        let option = document.createElement('option');
        option.value = cat02[i];
        option.textContent = cat02[i];
        selectCat.appendChild(option);
      }
    } else if(deptVal == '薬剤科') {
      for(let i = 0; i < cat03.length; i++){
        let option = document.createElement('option');
        option.value = cat03[i];
        option.textContent = cat03[i];
        selectCat.appendChild(option);
      }
    } else {
      for(let i = 0; i < cat04.length; i++){
        let option = document.createElement('option');
        option.value = cat04[i];
        option.textContent = cat04[i];
        selectCat.appendChild(option);
      }
    }

    catVal = selectCat.value;

    if(catVal == '個別病院見学' || catVal == 'インターンシップに関するお問い合わせ') {
      dateBox.style.display= 'block';
      datepicker.forEach((item) => {
        item.setAttribute('required', '');
      });
    } else {
      dateBox.style.display= 'none';
      datepicker.forEach((item) => {
        item.removeAttribute('required');
      });
    }

  });
}

if (selectCat) {
  selectCat.addEventListener('change', () => {
    catVal = selectCat.value;

    if(catVal == '個別病院見学' || catVal == 'インターンシップに関するお問い合わせ') {
      dateBox.style.display= 'block';
      datepicker.forEach((item) => {
        item.setAttribute('required', '');
      });
    } else {
      dateBox.style.display= 'none';
      datepicker.forEach((item) => {
        item.removeAttribute('required');
      });
    }

  });
}